module.exports = __webpack_public_path__ + "img/save-white.b8dcf2b6.svg";